import { c as _c } from "react/compiler-runtime";
import React, { useState, useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import FabricGrid from 'components/consumer/fabric-grid';
import MobileModal from 'components/consumer/MobileModal';
import ClearAllFiltersButton from 'components/consumer/ClearAllFiltersButton';
import CtaButton from 'components/essentials/Cta/CtaButton';
import { sortByOptions } from './utils';
import FabricPageHeader from './components/FabricPageHeader';
import MobileColorFilters from './components/MobileColorFilters';
import MobileTierFilters from './components/MobileTierFilters';
import FeaturesFilters from './components/FeaturesFilters';
import useFabricPageUrlSync from './hooks/useFabricPageUrlSync';
import useFabricsPageState from './hooks/useFabricsPageState';
const DEFAULT_FABRIC_LIST = [];
const mobileItemsPerRow = 3;
const openSidebarOnClick = true;
const wrapInFixedWidthContainer = false;
const showFavorites = false;
const desktopFilterSize = 210;
const FabricPage = props => {
  const $ = _c(73);
  const loading = !!props.loading;
  const fabricList = props?.data?.getFabrics || DEFAULT_FABRIC_LIST;
  const [isMobileSortByOpen, setIsMobileSortByOpen] = useState(false);
  const [isMobileFiltersOpen, setIsMobileFiltersOpen] = useState(false);
  const [currentMobileItemsPerRow, setCurrentMobileItemsPerRow] = useState(mobileItemsPerRow);
  const {
    parseQueryParams,
    syncStateToUrl,
    updateQueryParams
  } = useFabricPageUrlSync(props.history);
  const {
    initialSelectedFabric,
    selectedMaterialType,
    sortBy,
    selectedColors,
    selectedFeatures,
    selectedTiers,
    selectedFabric,
    fabricColors,
    fabricTiers,
    displayFabricList,
    handleMaterialTypeChange,
    handleSetSortBy,
    toggleSelectedColor,
    toggleSelectedFeature,
    toggleSelectedTier,
    onFabricSelection,
    clearAllFilters,
    numberOfActiveFilters
  } = useFabricsPageState(fabricList, parseQueryParams, syncStateToUrl, updateQueryParams);
  let t0;
  if ($[0] !== handleMaterialTypeChange) {
    t0 = {
      label: "Fabrics",
      id: "Fabric-FabricsPage",
      contentId: "Fabric",
      onClick: () => {
        handleMaterialTypeChange("Fabric");
      }
    };
    $[0] = handleMaterialTypeChange;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== handleMaterialTypeChange) {
    t1 = {
      label: "Leathers",
      id: "Leather-FabricsPage",
      contentId: "Leather",
      onClick: () => {
        handleMaterialTypeChange("Leather");
      }
    };
    $[2] = handleMaterialTypeChange;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = [t0, t1];
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const mobileButtonItems = t2;
  let t3;
  if ($[7] !== currentMobileItemsPerRow) {
    t3 = () => {
      const options = [1, 2, 3];
      const currentIndex = options.indexOf(currentMobileItemsPerRow);
      const nextIndex = (currentIndex + 1) % options.length;
      setCurrentMobileItemsPerRow(options[nextIndex]);
    };
    $[7] = currentMobileItemsPerRow;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const toggleMobileItemsPerRow = t3;
  const showColorFilters = selectedMaterialType === "Fabric" && fabricColors.length > 0;
  const showTierFilters = fabricTiers.length > 1;
  const showFeaturesFilters = selectedMaterialType === "Fabric";
  const mobileModalTitle = numberOfActiveFilters > 0 ? `Filters (${numberOfActiveFilters})` : "Filters";
  let t4;
  if ($[9] !== clearAllFilters || $[10] !== numberOfActiveFilters) {
    t4 = numberOfActiveFilters > 0 && <div className="md:bg-white md:h-10 relative"><ClearAllFiltersButton onClick={clearAllFilters} variant="ShopByMobile">Clear all</ClearAllFiltersButton></div>;
    $[9] = clearAllFilters;
    $[10] = numberOfActiveFilters;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const mobileModalHeader = t4;
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setIsMobileFiltersOpen(false);
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const t6 = displayFabricList.length || 0;
  const t7 = displayFabricList.length === 1 ? "" : "s";
  let t8;
  if ($[13] !== t6 || $[14] !== t7) {
    t8 = <CtaButton block={true} onClick={t5}>Done ({t6} result{t7})</CtaButton>;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const mobileModalFooter = t8;
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => setIsMobileFiltersOpen(false);
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== selectedFabric || $[18] !== selectedFeatures || $[19] !== showFeaturesFilters || $[20] !== toggleSelectedFeature) {
    t10 = showFeaturesFilters && <FeaturesFilters toggleSelectedFeature={toggleSelectedFeature} selectedFeatures={selectedFeatures} selectedFabric={selectedFabric} />;
    $[17] = selectedFabric;
    $[18] = selectedFeatures;
    $[19] = showFeaturesFilters;
    $[20] = toggleSelectedFeature;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== fabricColors || $[23] !== selectedColors || $[24] !== showColorFilters || $[25] !== toggleSelectedColor) {
    t11 = showColorFilters && <MobileColorFilters fabricColors={fabricColors} toggleSelectedColor={toggleSelectedColor} selectedColors={selectedColors} />;
    $[22] = fabricColors;
    $[23] = selectedColors;
    $[24] = showColorFilters;
    $[25] = toggleSelectedColor;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== fabricTiers || $[28] !== selectedTiers || $[29] !== showTierFilters || $[30] !== toggleSelectedTier) {
    t12 = showTierFilters && <MobileTierFilters fabricTiers={fabricTiers} toggleSelectedTier={toggleSelectedTier} selectedTiers={selectedTiers} />;
    $[27] = fabricTiers;
    $[28] = selectedTiers;
    $[29] = showTierFilters;
    $[30] = toggleSelectedTier;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== isMobileFiltersOpen || $[33] !== mobileModalFooter || $[34] !== mobileModalHeader || $[35] !== mobileModalTitle || $[36] !== t10 || $[37] !== t11 || $[38] !== t12) {
    t13 = <MobileModal title={mobileModalTitle} onClose={t9} isOpen={isMobileFiltersOpen} isFullHeight={true} headerRight={mobileModalHeader} stickyFooter={mobileModalFooter} closeIcon="arrow">{t10}{t11}{t12}</MobileModal>;
    $[32] = isMobileFiltersOpen;
    $[33] = mobileModalFooter;
    $[34] = mobileModalHeader;
    $[35] = mobileModalTitle;
    $[36] = t10;
    $[37] = t11;
    $[38] = t12;
    $[39] = t13;
  } else {
    t13 = $[39];
  }
  let t14;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = () => setIsMobileFiltersOpen(true);
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  let t15;
  if ($[41] !== currentMobileItemsPerRow || $[42] !== fabricColors || $[43] !== fabricTiers || $[44] !== handleSetSortBy || $[45] !== isMobileSortByOpen || $[46] !== mobileButtonItems || $[47] !== numberOfActiveFilters || $[48] !== selectedColors || $[49] !== selectedFabric || $[50] !== selectedFeatures || $[51] !== selectedMaterialType || $[52] !== selectedTiers || $[53] !== showColorFilters || $[54] !== showFeaturesFilters || $[55] !== showTierFilters || $[56] !== sortBy || $[57] !== toggleMobileItemsPerRow || $[58] !== toggleSelectedColor || $[59] !== toggleSelectedFeature || $[60] !== toggleSelectedTier) {
    t15 = <FabricPageHeader selectedMaterialType={selectedMaterialType} selectedColors={selectedColors} selectedFeatures={selectedFeatures} selectedTiers={selectedTiers} selectedFabric={selectedFabric} fabricColors={fabricColors} fabricTiers={fabricTiers} sortBy={sortBy} sortByOptions={sortByOptions} showFavorites={showFavorites} numberOfActiveFilters={numberOfActiveFilters} showColorFilters={showColorFilters} showFeaturesFilters={showFeaturesFilters} showTierFilters={showTierFilters} isMobileSortByOpen={isMobileSortByOpen} mobileItemsPerRow={currentMobileItemsPerRow} mobileButtonItems={mobileButtonItems} bannerHeight={430} setSortBy={handleSetSortBy} toggleSelectedColor={toggleSelectedColor} toggleSelectedFeature={toggleSelectedFeature} toggleSelectedTier={toggleSelectedTier} toggleMobileSortByOpen={setIsMobileSortByOpen} toggleMobileItemsPerRow={toggleMobileItemsPerRow} toggleMobileFiltersOpen={t14} />;
    $[41] = currentMobileItemsPerRow;
    $[42] = fabricColors;
    $[43] = fabricTiers;
    $[44] = handleSetSortBy;
    $[45] = isMobileSortByOpen;
    $[46] = mobileButtonItems;
    $[47] = numberOfActiveFilters;
    $[48] = selectedColors;
    $[49] = selectedFabric;
    $[50] = selectedFeatures;
    $[51] = selectedMaterialType;
    $[52] = selectedTiers;
    $[53] = showColorFilters;
    $[54] = showFeaturesFilters;
    $[55] = showTierFilters;
    $[56] = sortBy;
    $[57] = toggleMobileItemsPerRow;
    $[58] = toggleSelectedColor;
    $[59] = toggleSelectedFeature;
    $[60] = toggleSelectedTier;
    $[61] = t15;
  } else {
    t15 = $[61];
  }
  let t16;
  if ($[62] !== clearAllFilters || $[63] !== displayFabricList || $[64] !== initialSelectedFabric || $[65] !== loading || $[66] !== onFabricSelection || $[67] !== sortBy) {
    t16 = !loading && <FabricGrid fabricList={displayFabricList} clearAllFilters={clearAllFilters} mobileItemsPerRow={mobileItemsPerRow} openSidebarOnClick={openSidebarOnClick} sortBy={sortBy} wrapInFixedWidthContainer={wrapInFixedWidthContainer} showFavorites={showFavorites} desktopFilterSize={desktopFilterSize} initialSelection={initialSelectedFabric} onFabricSelection={onFabricSelection} />;
    $[62] = clearAllFilters;
    $[63] = displayFabricList;
    $[64] = initialSelectedFabric;
    $[65] = loading;
    $[66] = onFabricSelection;
    $[67] = sortBy;
    $[68] = t16;
  } else {
    t16 = $[68];
  }
  let t17;
  if ($[69] !== t13 || $[70] !== t15 || $[71] !== t16) {
    t17 = <div className="flex flex-col relative lg:block">{t13}{t15}{t16}</div>;
    $[69] = t13;
    $[70] = t15;
    $[71] = t16;
    $[72] = t17;
  } else {
    t17 = $[72];
  }
  return t17;
};
export default withRouter(FabricPage);